<ng-container *ngIf="(layerStore.activeLayer | async) as activeLayer">
  <div class="popup-container" [ngClass]="data.type === HOVER_POPUP ? 'hover-popup' : ''" *ngIf="(layerStore.activeLevel | async) as activeLevel" [attr.data-cy]="'mapPopup'">
    <button app-icon-button iconSize="12px" class="close-button" [attr.data-cy]="'close-popup-button'" (click)="handleClose()" *ngIf="data.type !== HOVER_POPUP">
      <app-icon svgIcon="cancel"></app-icon>
    </button>

    <ng-container [ngSwitch]="data.type">
      <app-layers-popup-list *ngSwitchCase="DEFAULT_POPUP"
                             [title]="popupService.popupTitle"
                             [properties]="$any(data).properties | sortProperties"
                             [isSeeMoreActive]="popupService.isSeeMoreActive"
                             [activeLayer]="activeLayer"
                             [activeLevel]="activeLevel"
      >
      </app-layers-popup-list>

      <app-layers-popup-list
      *ngSwitchCase="HOVER_POPUP"
      [title]="$any(data).properties.name ?? (layerStore.activeLevel.value === H3_RES5_LEVEL_LAYER ? 'Cell (5 mile)' : 'Cell (1 mile)')"
      [properties]="$any(data).properties | sortProperties"
      [activeLayer]="activeLayer"
      [activeLevel]="activeLevel"
      [isHoverPopup]="true"
      >
      </app-layers-popup-list>

      <app-schools-popup-list *ngSwitchCase="SCHOOLS_POPUP"
                              [properties]="$any(data).properties"
                              [isSeeMoreActive]="popupService.isSeeMoreActive"
      >
      </app-schools-popup-list>

      <app-ori-popup-list *ngSwitchCase="ORI_POPUP"
                          [properties]="$any(data).properties"
                          [isSeeMoreActive]="popupService.isSeeMoreActive"
      ></app-ori-popup-list>
    </ng-container>
    <button class="toggle-data-count" (click)="toggleSeeMore()" *ngIf="data.type !== HOVER_POPUP">
      {{ popupService.isSeeMoreActive ? 'Hide' : 'See more' }}
    </button>

    <div class="popup-tools" *ngIf="data.type === DEFAULT_POPUP">
      <button
        app-icon-button
        iconSize="12px"
        *ngIf="!accessService.isUnauthorized"
        (click)="isFeatureFavorite() ? handleRemoveFromFavorites() : handleAddToFavorites()"
        [matTooltip]="'Mark cell as favorite'"
        class="round-button"
      >
        <app-favorite-icon
          [strokeColor]="isFeatureFavorite() ? '#CA0018' : '#02a4ff'"
          [fillColor]="isFeatureFavorite() ? '#CA0018' : '#fff'"
          width="14px"
          height="14px"
        >
        </app-favorite-icon>
      </button>

      <button
        app-icon-button
        iconSize="14px"
        class="ai-description-button"
        [ngClass]="accessService.isUnauthorized ? 'disabled' : ''"
        matTooltipPosition="right"
        [matTooltip]='accessService.isUnauthorized ? "To get access to the feature, you need to sign in" : ""'
        (click)="handleAreaDescriptionClick()">
        <span class="btn-title">
        Summary
                  </span>

         <app-feature-tooltip *ngIf="accessService.isUnauthorized"
                                       [isFeatureInaccessibleType]="true"
                                       [strokeColor]="'#cccccc'"
                                       (openTooltipModal)="handleTooltipModalOpen($event)"
                  ></app-feature-tooltip>

        <app-icon *ngIf="!accessService.isUnauthorized" svgIcon="gpt"></app-icon>
      </button>

      <button
        class="round-button"
        app-icon-button
        iconSize="16px"
        *ngIf="accessService.getIsAdmin()"
        (click)="handleDownloadXlsx()"
        [matTooltip]="'Download data (xlsx)'">
        <app-icon svgIcon="download"></app-icon>
      </button>

      <button
        class="round-button"
        app-icon-button
        iconSize="16px"
        (click)="handleShare()"
        [matTooltip]="'Copy location to clipboard'">
        <app-icon svgIcon="share"></app-icon>
      </button>

      <button
        (click)="accessService.isUnauthorized ? goToSignUp() : handleRequestReport()"
        class="report-button"
        [matTooltip]="accessService.isUnauthorized ? 'Go to sign up' : 'Request report'"
        app-icon-button
        iconSize="14px"
      >
        {{accessService.isUnauthorized ? 'Start free trial' : 'Get my report'}}
        <app-icon *ngIf="!accessService.isUnauthorized" svgIcon="report"></app-icon>
      </button>
    </div>
  </div>
</ng-container>
